import './bootstrap';

// Chart Js
import Chart from 'chart.js/auto';
window.Chart = Chart;

// ConfirmationModal
import ConfirmModal from './confirmation-modal';
window.ConfirmModal = ConfirmModal;

//
// Create (admin)
//

// FormCreate
import FormCreate from './form-create';
window.FormCreate = FormCreate;

// QaCreate
import QaCreate from './qa-create';
window.QaCreate = QaCreate;

// DmCreate
import DmCreate from './dm-create';
window.DmCreate = DmCreate;

//
// Compose (employee)
//

// FormCompose
import FormCompose from './form-compose';
window.FormCompose = FormCompose;

// QaCompose
import QaCompose from './qa-compose';
window.QaCompose = QaCompose;

// DmCompose
import DmCompose from './dm-compose';
window.DmCompose = DmCompose;

// ComposePointsAutoFail
import ComposePointsAutoFail from './compose-points-autofail';
window.ComposePointsAutoFail = ComposePointsAutoFail;

//
// View
//

// DmView
import DmView from './dm-view';
window.DmView = DmView;

